import CryptoJS from "crypto-js";
export default {
    Encrypt: (data) => {
        try {
            const salt = "4t3WrsiX*HJ@R%dv55c9Nn";
            const ciphertext = CryptoJS.AES.encrypt(data, salt).toString();
            const urlSafeCiphertext = ciphertext.replace(/\+/g, "-").replace(/\//g, "_");
            return urlSafeCiphertext;
        } catch (error) {
            console.log('ecncyptioneroorrrrrrrrr', error)
            // console.error(Messages.Error.Secure.ENCRYPT, error);
        }
    },
    Decrypt: (encryptedText) => {
        try {
            const salt = "4t3WrsiX*HJ@R%dv55c9Nn";
            const base64Ciphertext = encryptedText.replace(/-/g, "+").replace(/_/g, "/");
            var bytes = CryptoJS.AES.decrypt(base64Ciphertext, salt);
            var originalText = bytes.toString(CryptoJS.enc.Utf8);
            return originalText;
        } catch (error) {
            // console.error(Messages.Error.Secure.DECRYPT, error);
        }
    }
}